import React, { useContext, useState } from 'react';
import Table, { RowsPerPageSelect } from '../../../../../../components/Table/Table';
import { Link } from 'react-router-dom';

import LoadAndRender from '../../../../../../components/LoadAndRender/LoadAndRender';
import SelectClassSection from '../../../../../../components/SelectClassSection/SelectClassSection';

import CollectFeeModal from './CollectFeeModal';
import { useMutation, useQuery } from '@apollo/client';
import { GET_SECTION_DATA, GET_STUDENTS } from './Queries';
import { dashboardContext } from '../../../../Dashboard';
import { Mixpanel } from '../../../../../../util/mixpanel';
import { SEND_WHATSAPP_REMINDER_TO_STUDENT } from '../../../StudentProfile/pages/studentDetails/Queries';
import ConfirmationBox from '../../../../../../components/ConfirmationBox/ConfirmationBox';
import Modal from '../../../../../../components/Modal/Modal';
import CollectFeeButton from '../CollectFee/CollectFeeButton';
import Pagination from '../../../../../../components/Pagination/Pagination';
const get_collection = async (section_id: string) => {
	var myHeaders = new Headers();
	myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('token'));

	var requestOptions: RequestInit = {
		method: 'GET',
		headers: myHeaders,
		redirect: 'follow',
	};

	const res = await fetch(
		process.env.REACT_APP_BACKEND_URL + '/api/fee-collection/section/' + section_id,
		requestOptions,
	);
	if (res.ok) {
		return await res.json();
	} else {
		const message = await res.json();
		if (message.statusCode === 401) {
			localStorage.removeItem('token');
			window.location.reload();
		}
	}
};

// const get_amount = async (arr: any, id: any) => {
// 	let myHeaders = new Headers();
// 	myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
// 	var requestOptions: RequestInit = {
// 		method: 'GET',
// 		headers: myHeaders,
// 		redirect: 'follow',
// 	};

// 	const res = await fetch(
// 		process.env.REACT_APP_BACKEND_URL +
// 			`/api/fee-collection/calculate_amount?student_id=${id}&installments=${JSON.stringify(arr)}`,
// 		requestOptions,
// 	);
// 	if (res.ok) {
// 		return await res.json();
// 	} else {
// 		const message = await res.json();
// 		if (message.statusCode === 401) {
// 			localStorage.removeItem('token');
// 			window.location.reload();
// 		}
// 	}
// };
// const getFineByStudentId = async (id: any) => {
// 	console.log({ id });
// 	let myHeaders = new Headers();
// 	myHeaders.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
// 	var requestOptions: RequestInit = {
// 		method: 'GET',
// 		headers: myHeaders,
// 		redirect: 'follow',
// 	};

// 	const res = await fetch(process.env.REACT_APP_BACKEND_URL + `/api/student/fine?id=${id}`, requestOptions);
// 	if (res.ok) {
// 		return await res.json();
// 	} else {
// 		const message = await res.json();
// 		if (message.statusCode === 401) {
// 			localStorage.removeItem('token');
// 			window.location.reload();
// 		}
// 	}
// };

const CollectOverview = ({ _loading }: any) => {
	const [_class, set_class] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [student, setStudent] = useState<any>(null);
	// const [students, setStudents] = useState<any>([]);
	const [section, set_section] = useState('');
	const [search_input, set_search_input] = useState('');
	const { user } = useContext(dashboardContext);
	const [send_whatsapp_reminder_to_student] = useMutation(SEND_WHATSAPP_REMINDER_TO_STUDENT);
	const [sendReminderConfirmationModal, setSendReminderConfirmationModal] = useState(false);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState({
		name: 10,
	});
	// const {
	// 	data: section_data,
	// 	loading,
	// 	error,
	// } = useQuery(GET_SECTION_DATA, {
	// 	variables: { class: _class, section: section },
	// });

	const {
		data: studentData,
		loading: studentLoading,
		error: studentError,
	} = useQuery(GET_STUDENTS, {
		variables: {
			school_id: user?.school?._id,
			trustee_id: user?.school?.trustee_id,
			student_id: null,
			page,
			limit: limit?.name,
		},
	});

	return (
		<div>
			{/* <div className='w-1/2'>
				<SelectClassSection
					className='flex'
					onChange={(s: any) => {
						set_section(s._id);
						set_class(s.class);
						set_section(s.section);
					}}
				></SelectClassSection>
			</div> */}
			{/* <CollectFeeModal
				student={student}
				setStudents={(s: any) => {}}
				get_collection={get_collection}
				showModal={showModal}
				setShowModal={setShowModal}
				students={students}
			/> */}
			<Modal open={sendReminderConfirmationModal} setOpen={setSendReminderConfirmationModal}>
				<ConfirmationBox
					setOpen={setSendReminderConfirmationModal}
					funtion={() => {
						send_whatsapp_reminder_to_student({
							variables: {
								student_id: student?._id,
							},
						});
					}}
					confirmationText='send reminder'
					ButtonText='Send Reminder'
				/>
			</Modal>

			<LoadAndRender loading={studentLoading}>
				{studentData && (
					<div className='w-full'>
						{/* <h2>this div may need to remove after some fixes</h2> */}
						<div className='grid grid-cols-7'>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
						<Table
							heading={
								<div>
									<div className='bg-[#817DFF] mt-2 max-w-md h-12 mb-2 ml-2 items-center bg-opacity-10 flex py-3 px-6 rounded-[24px]'>
										<i className='text-edvion_black text-opacity-50 fa-solid fa-magnifying-glass'></i>
										<input
											onChange={(e) => set_search_input(e.target.value)}
											type='text'
											placeholder='Search by student name, enrolment number'
											className='ml-4 bg-transparent focus:outline-none w-full placeholder:font-normal placeholder:text-base'
										/>
									</div>
								</div>
							}
							perPage={
								<div className=' flex justify-end items-center  '>
									<RowsPerPageSelect
										setItemsPerRow={(e: any) => {
											setLimit(e);
										}}
										itemsPerRow={limit}
										className=' justify-start'
									/>
								</div>
							}
							data={[
								['Sr.No', 'Name', 'Email ID', 'Roll No.', 'Total Amount', 'Total Paid', 'Total Due', 'Action', ''],

								...studentData.getStudents.students_detail
									// .filter((s: any) =>
									// 	[s.name, s.father_name, s.school_generated_id]
									// 		.join(',')
									// 		.toLowerCase()
									// 		.includes(search_input.toLowerCase()),
									// )
									//.sort((a: any, b: any) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
									.map((r: any, index: number) => [
										<span className='w-20'>{(page - 1) * limit.name + index + 1}</span>,
										<Link to={'/student_profile/' + r.student_id} state={{ student: r }}>
											<span className='text-base text-violet-500'>{r?.student_name ? r?.student_name : '-'}</span>
										</Link>,
										r?.student_email,
										r?.school_generated_id ? r?.school_generated_id : 'N/A',
										<h2> {r?.total_amount ? '₹ ' + r?.total_amount?.toLocaleString('hi') : 'N/A'}</h2>,
										<h2 className={'' + (r?.previous_session_dues_paid ? ' text-[#2EB418]' : ' ')}>
											{r?.previous_session_dues_paid
												? '₹ ' + r?.previous_session_dues_paid?.toLocaleString('hi')
												: 'N/A'}
										</h2>,
										<h2 className={' ' + (r?.previous_session_dues ? ' text-[#FC4343]' : '')}>
											{r?.previous_session_dues ? '₹ ' + r?.previous_session_dues?.toLocaleString('hi') : 'N/A'}
										</h2>,
										<CollectFeeButton school_id={r?.school_id} student_id={r?.student_id} />,
										// <button
										// 	onClick={() => {
										// 		// setShowModal(true);
										// 		setStudent(r);

										// 		// Mixpanel.track('collect_fee_button', {
										// 		// 	user_name: user?.name,
										// 		// 	schoolId: r.school?.id,
										// 		// 	school: r.school?.name,
										// 		// 	studentId: r?._id,
										// 		// 	studentName: r?.name,
										// 		// });
										// 	}}
										// 	className={` py-1.5 text-edvion_black text-base bg-indigo-200 px-4 rounded-[8px] `}
										// >
										// 	Collect Fee
										// </button>,
										<div>
											<i
												onClick={() => {
													setStudent(r);
													setSendReminderConfirmationModal(true);
												}}
												className='fa-solid fa-ellipsis-vertical cursor-pointer'
												aria-hidden='true'
											></i>
										</div>,
									]),
							]}
							footer={<Pagination page={page} setPage={setPage} totalPageNo={studentData.getStudents?.total_pages} />}
						/>
					</div>
				)}
			</LoadAndRender>
		</div>
	);
};

export default CollectOverview;
